import { Type } from '@angular/core';
import { BaseControlInterface, ImpexGenericControlInterface } from '@y42/impex';

export interface ExportControlInterface<T> extends BaseControlInterface<T> {
  implicit_form?: boolean;
}

export type GenericControlInterface<T> = ImpexGenericControlInterface<T> | ExportControlInterface<T>;

export enum ExportTypePropertyType {
  Boolean = 'boolean',
  String = 'string',
  Integer = 'integer',
  Array = 'array',
  Object = 'object',
}

export enum ExportTypePropertyFormat {
  DateTime = 'date-time',
  Password = 'password',
}

export enum ExportPropertyValidator {
  Email = 'email',
}

export interface $ref {
  $ref: string;
}

export interface ExportTypeProperty {
  type: ExportTypePropertyType;
  title: string;
  description?: string;
  format?: ExportTypePropertyFormat;
  default?: unknown;
  items?: {
    $ref: string;
    anyOf: $ref[];
  };
  allOf?: $ref[];
  anyOf?: $ref[];
  metadata?: {
    from_resource?: string;
    multiple?: boolean;
    implicit_form?: boolean;
    validation: ExportPropertyValidator[];
    wording?: Record<string, string>;
    show_dropdown_value?: boolean;
    order?: number;
  };
}

export interface ExportTypeDefinition {
  title: string;
  type: string;
  description?: string;
  properties?: Record<string, ExportTypeProperty>;
  enum?: string[];
  required?: string[];
}

interface ExportTypeJSONSchema extends Record<string, unknown> {
  $schema: string;
  title: string;
  type: string;
  required?: string[];
  properties?: Record<string, ExportTypeProperty>;
  definitions?: Record<string, ExportTypeDefinition>;
}

export interface ExportTypeSourceJSONSchema extends ExportTypeJSONSchema {
  imageURL?: string;
  description?: string;
  settings: {
    authType: ExportAuthType;
    hasSchema: boolean;
  };
}

export interface ExportTypeSecretJSONSchema extends ExportTypeJSONSchema {
  settings?: Record<string, unknown>;
  oauth?: {
    client_params: string[];
    url_params: string[];
  };
}

export interface ExportTypeTableJSONSchema extends ExportTypeJSONSchema {}

export enum ExportAuthType {
  NONE = 'NONE',
  Oauth = 'OAUTH',
  GoogleKey = 'GOOGLE_KEY',
  Token = 'TOKEN',
}

export interface BaseAuthSettingsModel {}

export interface ExportAuthComponentInterface<T = BaseAuthSettingsModel> {
  authSettings?: T;
}

export interface ExportAuthInterface<T = BaseAuthSettingsModel> {
  auth: {
    authSettings?: T;
    authComponent: Type<ExportAuthComponentInterface<T>> | null;
  };
}
